import React from 'react';
import { useTranslation } from 'react-i18next';
import { Accordion } from 'react-bootstrap';

import { Modal } from 'modules/common/components';
import { ContextAwareToggle } from 'modules/common/components';
import { ReactComponent as Cross } from 'images/cross.svg';

interface HowDoesItWorkModalProps {
  onClose: () => void;
}

export default function HowDoesItWorkModal({
  onClose,
}: HowDoesItWorkModalProps) {
  const { t } = useTranslation(['zvrRegistration']);

  return (
    <Modal show onHide={onClose}>
      <div className="t-flex t-justify-between">
        <h1 className="typo-alpha">{t('zvrRegistration:how_work_title')}</h1>
        <button
          onClick={onClose}
          className="t-float-right t-outline-none"
          type="button"
        >
          <Cross />
        </button>
      </div>

      <Accordion defaultActiveKey="0" className="t-mt-10">
        <div className="t-pb-4" key={0}>
          <div className="t-flex t-items-center t-justify-between">
            <h2 className="typo-beta">{t('zvrRegistration:question_1')}</h2>

            <div className="sm:t-mr-3 ">
              <ContextAwareToggle hideText eventKey={`${0}`} />
            </div>
          </div>
          <Accordion.Collapse eventKey={`${0}`}>
            <div className="sm:t-flex t-mt-3">
              {t('zvrRegistration:question_1_answer')}
            </div>
          </Accordion.Collapse>
        </div>

        <hr className="t-mr-3 t-mb-5 t-border-none t-h-px t-text-beta-200 t-bg-beta-200" />

        <div className="t-pb-4" key={1}>
          <div className="t-flex t-items-center t-justify-between">
            <h2 className="typo-beta">{t('zvrRegistration:question_2')}</h2>

            <div className="sm:t-mr-3">
              <ContextAwareToggle hideText eventKey={`${1}`} />
            </div>
          </div>
          <Accordion.Collapse eventKey={`${1}`}>
            <div className="sm:t-flex t-mt-3">
              {t('zvrRegistration:question_2_answer')}
            </div>
          </Accordion.Collapse>
        </div>

        <hr className="t-mr-3 t-mb-5 t-border-none t-h-px t-text-beta-200 t-bg-beta-200" />

        <div className="t-pb-4" key={2}>
          <div className="t-flex t-items-center t-justify-between">
            <h2 className="typo-beta">{t('zvrRegistration:question_3')}</h2>

            <div className="sm:t-mr-3">
              <ContextAwareToggle hideText eventKey={`${2}`} />
            </div>
          </div>
          <Accordion.Collapse eventKey={`${2}`}>
            <div className="sm:t-flex t-mt-3">
              {t('zvrRegistration:question_3_answer')}
            </div>
          </Accordion.Collapse>
        </div>

        <hr className="t-mr-3 t-mb-5 t-border-none t-h-px t-text-beta-200 t-bg-beta-200" />

        <div className="t-pb-4" key={3}>
          <div className="t-flex t-items-center t-justify-between">
            <h2 className="typo-beta">{t('zvrRegistration:question_4')}</h2>

            <div className="sm:t-mr-3">
              <ContextAwareToggle hideText eventKey={`${3}`} />
            </div>
          </div>
          <Accordion.Collapse eventKey={`${3}`}>
            <div className="sm:t-flex t-mt-3">
              {t('zvrRegistration:question_4_answer')}
            </div>
          </Accordion.Collapse>
        </div>
      </Accordion>
    </Modal>
  );
}
